import { useEffect, useState } from 'react'

import { profile } from '../../data/portfolio'
import AnimatedLetters from '../AnimatedLetters'
import ArrowIcon from '../ArrowIcon'
import './index.scss'

export default function Resume() {
  const [letterClass, setLetterClass] = useState('text-animate')
  useEffect(() => { const timer = setTimeout(() => setLetterClass('text-animate-hover'), 2000); return () => clearTimeout(timer) }, [])
  return <div className="container resume-page">
    <div className="text-zone">
      <h1><AnimatedLetters letterClass={letterClass} strArray={'Resume'.split('')} idx={15} /></h1>
      <p>{profile.summary}</p>
      <p>Education, technical skills, Kestrel, and my experience — together in one document.</p>
      <div className="resume-actions">
        <a className="flat-button" href={profile.resume} target="_blank" rel="noreferrer">VIEW PDF <ArrowIcon /></a>
        <a className="flat-button" href={profile.resume} download="Omar-Abdelrazek-Resume.pdf">DOWNLOAD <ArrowIcon down /></a>
      </div>
    </div>
    <section className="resume-viewer" aria-label="Resume preview">
      <header><span className="status-dot" /> Omar Abdelrazek <span>RESUME / PDF</span></header>
      <a className="resume-document" href={profile.resume} target="_blank" rel="noreferrer" aria-label="Open the full resume PDF"><img src="/resume/preview.png" alt="Preview of Omar Abdelrazek’s resume: summary, education, technical skills, Kestrel project, and experience." /></a>
      <p>Read or print: <a href={profile.resume} target="_blank" rel="noreferrer">Open the PDF directly <ArrowIcon /></a></p>
    </section>
  </div>
}
